import React from 'react';
import { Formik, Form } from 'formik';

import { FormElement, Label } from '@dashboard/components/Form';

import { Checkbox, TextInput } from '@dashboard/components/Formik';

import { isEmpty } from 'lodash';
import FormSubmit from '@dashboard/components/Formik/components/FormSubmit';
import { transformApiErrorToFormik } from '@dashboard/services/form';
import FormError from '@dashboard/components/Formik/components/FormError';
import CanUseFeature from '@dashboard/components/CanUseFeature';
import Features from '@dashboard/enums/features';
import usePage from '@dashboard/hooks/usePage';

const NotificationsForm = () => {
  const { page, updatePage } = usePage();

  return (
    <Formik
      initialValues={{
        sendPaymentNotification: page?.sendPaymentNotification,
        notifyEmail: page?.notifyEmail,
        sendCanceledSubscriptionNotifications: page?.sendCanceledSubscriptionNotifications,
        sendRecurringPaymentFailedNotifications: page?.sendRecurringPaymentFailedNotifications,
        sendRecurringPaymentSucceededNotifications:
          page?.sendRecurringPaymentSucceededNotifications,
      }}
      onSubmit={async (values, actions) => {
        actions.setStatus(undefined);

        const { data, error } = await updatePage.mutateAsync(values);

        if (data) {
          actions.setStatus('');
          actions.resetForm({
            values: {
              sendPaymentNotification: data.sendPaymentNotification,
              notifyEmail: data.notifyEmail,
              sendCanceledSubscriptionNotifications: data.sendCanceledSubscriptionNotifications,
              sendRecurringPaymentFailedNotifications: data.sendRecurringPaymentFailedNotifications,
              sendRecurringPaymentSucceededNotifications:
                data.sendRecurringPaymentSucceededNotifications,
            },
          });
        } else {
          const { status, errors } = transformApiErrorToFormik(error);

          if (!isEmpty(errors)) {
            actions.setErrors(errors);
          } else {
            actions.setStatus(status);
          }
        }
      }}
    >
      {({ status, dirty, handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <FormElement className="space-y-2">
            <Checkbox.Wrapper>
              <Checkbox id="sendPaymentNotification" name="sendPaymentNotification" />
              <Checkbox.Label htmlFor="sendPaymentNotification">
                Receive email notifications
              </Checkbox.Label>
            </Checkbox.Wrapper>

            <FormError name="sendPaymentNotification" />

            <>
              {page?.productType === 'subscription' && (
                <>
                  <Checkbox.Wrapper>
                    <Checkbox
                      id="sendCanceledSubscriptionNotifications"
                      name="sendCanceledSubscriptionNotifications"
                    />
                    <Checkbox.Label htmlFor="sendCanceledSubscriptionNotifications">
                      Receive notifications of canceled subscriptions
                    </Checkbox.Label>
                  </Checkbox.Wrapper>

                  <FormError name="sendCanceledSubscriptionNotifications" />

                  <Checkbox.Wrapper>
                    <Checkbox
                      id="sendRecurringPaymentSucceededNotifications"
                      name="sendRecurringPaymentSucceededNotifications"
                    />
                    <Checkbox.Label htmlFor="sendRecurringPaymentSucceededNotifications">
                      Receive notifications of recurring successful payments
                    </Checkbox.Label>
                  </Checkbox.Wrapper>

                  <FormError name="sendRecurringPaymentSucceededNotifications" />

                  <Checkbox.Wrapper>
                    <Checkbox
                      id="sendRecurringPaymentFailedNotifications"
                      name="sendRecurringPaymentFailedNotifications"
                    />
                    <Checkbox.Label htmlFor="sendRecurringPaymentFailedNotifications">
                      Receive notifications of recurring failed payments
                    </Checkbox.Label>
                  </Checkbox.Wrapper>

                  <FormError name="sendRecurringPaymentFailedNotifications" />
                </>
              )}
            </>
          </FormElement>

          <>
            <FormElement>
              <CanUseFeature feature={Features.NOTIFY_EMAIL}>
                <Label>Add more recipients</Label>

                <TextInput
                  id="notifyEmail"
                  name="notifyEmail"
                  type="text"
                  placeholder="johndoe@gmail.com, janedoe@gmail.com"
                  border
                />
                <FormError name="notifyEmail" />
              </CanUseFeature>
            </FormElement>
          </>

          {status && <FormElement>{status}</FormElement>}

          <FormSubmit>
            <FormSubmit.Button>Save</FormSubmit.Button>
            <FormSubmit.State visible={!!dirty} />
          </FormSubmit>
        </Form>
      )}
    </Formik>
  );
};

export default NotificationsForm;
